import { Reducer } from 'react';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { ForkEffect } from 'redux-saga/effects';

import {
  reducerUncatchedErrorMiddleware,
  sagaFailureActionMiddleware,
  sagaUncatchedErrorMiddleware,
} from 'utils/middlewares';

import { BaseObject } from 'types/shared';

import { createRootReducer } from './reducers';
import { rootSagas } from './sagas';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export const configureStore = (
  additionalReducers?: BaseObject<Reducer<unknown, unknown>>,
  additionalSagas?: ForkEffect[]
) => {
  const sagaMiddleware = createSagaMiddleware({
    onError: sagaUncatchedErrorMiddleware,
  });
  const store = createStore(
    createRootReducer(additionalReducers),
    composeWithDevTools(
      applyMiddleware(
        sagaMiddleware,
        reducerUncatchedErrorMiddleware,
        sagaFailureActionMiddleware
      )
    )
  );

  sagaMiddleware.run(() => rootSagas(additionalSagas));

  return store;
};
